import { Model } from './model';
import { QuotaItem } from './pojos';

export class BatchLine extends Model {
  id: number;
  amount: number;
  target_mode: string;
  external_alias: string;
  external_code: string;
  quota_origin: QuotaItem;
  quota_destination: QuotaItem;
  batch: number;

  constructor(values: Object = {}) {
    super(values);
  }

  public apiMap(values: Object = {}) {
    const record = new BatchLine(values);

    if (values['quota_origin']) {
      record.quota_origin = new QuotaItem(values['quota_origin']);
    }

    if (values['quota_destination']) {
      record.quota_destination = new QuotaItem(values['quota_destination']);
    }
    return record;
  }

  public serialize() {
    const record = super.serialize();
    record['quota_origin'] = (this.quota_origin && this.quota_origin.id) || null;
    record['quota_destination'] = (this.quota_destination && this.quota_destination.id) || null;

    return record;
  }
}



// WEBPACK FOOTER //
// ./src/app/_models/batch-line.ts